import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { LOGO_DARK } from "@/lib/brand";

const LOGO_URL = LOGO_DARK;

const navItems = [
  { to: "/", label: "Home" },
  { to: "/intros", label: "Expert Consultation" },
  { to: "/endorsements", label: "Endorsements" },
  { to: "/press", label: "Press Kit" },
  { to: "/#contact", label: "Contact" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-cream/90 backdrop-blur border-b border-navy/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="site-logo-link"
          className="flex items-center gap-4 group"
        >
          <img
            src={LOGO_URL}
            alt="Joseph Poche"
            decoding="async"
            className="h-16 w-16 object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <a
              key={n.to}
              href={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm text-navy/80 hover:text-navy transition-colors"
            >
              {n.label}
            </a>
          ))}
          <Link
            to="/login"
            data-testid="nav-cta-login"
            className="text-xs uppercase tracking-widest border border-navy text-navy px-4 py-2 hover:bg-navy hover:text-gold transition-colors"
          >
            CRM Login
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2 text-navy"
          aria-label="Toggle navigation"
        >
          <span className="block w-6 h-px bg-navy mb-1.5" />
          <span className="block w-6 h-px bg-navy mb-1.5" />
          <span className="block w-4 h-px bg-navy ml-auto" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-navy/10 bg-cream px-6 py-4 space-y-3" data-testid="mobile-menu">
          {navItems.map((n) => (
            <a
              key={n.to}
              href={n.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              className="block text-sm text-navy/80"
            >
              {n.label}
            </a>
          ))}
          <Link
            to="/login"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-login"
            className="block text-xs uppercase tracking-widest text-gold-deep"
          >
            CRM Login →
          </Link>
        </div>
      )}
    </header>
  );
}
